import { forwardRef } from "react";

export const CopyIcon = forwardRef<
    SVGSVGElement,
    React.SVGProps<SVGSVGElement>
>((props, ref) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
        ref={ref}
    >
        <path
            d="M13 11C13 12.1046 12.1046 13 11 13L5 13C3.89543 13 3 12.1046 3 11L3 5C3 3.89543 3.89543 3 5 3L11 3C12.1046 3 13 3.89543 13 5L13 11Z"
            fill="currentColor"
        />
        <path
            d="M15 17C16.1046 17 17 16.1046 17 15V9C17 7.89543 16.1046 7 15 7L15 15L7 15C7 16.1046 7.89543 17 9 17H15Z"
            fill="currentColor"
        />
    </svg>
));

CopyIcon.displayName = "CopyIcon";
